"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendFilled = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SendFilled = function SendFilled() {
  return react_1.default.createElement("path", {
    d: "M23.9586 1.26539L15.9731 23.5607C15.8779 23.8243 15.6278 23.9999 15.3476 24H15.1346C14.8733 23.9999 14.6352 23.8498 14.5224 23.614L11.3814 16.9587C10.9189 15.9775 11.0979 14.8138 11.834 14.017L15.8267 9.6511C16.0718 9.39401 16.0718 8.98976 15.8267 8.73267L15.321 8.22686C15.0639 7.98178 14.6597 7.98178 14.4026 8.22686L10.0372 12.2201C9.24053 12.9561 8.07695 13.1352 7.09588 12.6726L0.441271 9.53131C0.184645 9.43467 0.0113632 9.1931 0.00206702 8.91902V8.70605C-0.0215022 8.40656 0.158456 8.12842 0.441271 8.0272L22.7342 0.0408042C22.9739 -0.0472142 23.2428 0.00967439 23.4263 0.187221L23.7723 0.533299C23.9803 0.715016 24.0545 1.00633 23.9586 1.26539Z",
    fill: "currentColor"
  });
};

exports.SendFilled = SendFilled;